import dwhExport from '~/dwhExport'
import { Dialog, Divider, Tabs } from "@wg/wows-react-uikit";
import { CurrencyType } from "@wg/wows-react-uikit/Currency";
import get from 'lodash/get';
import React, { PureComponent } from "react";
import { t } from "../../helpers/localization";
import { Balance, IDateFormats, Transaction } from "../../Reducers/ReducerTreasury";
import "./calendar.scss";
import ClanBalance from "./ClanBalance/ClanBalance";
import Distribution from "./Distribution/Distribution";
import DistributionDialog from "./DistributionDialog/DistributionDialog";
import History from "./History/History";
import RegularRewards from './RegularRewards/RegularRewards';
import TransactionDetailDialog from "./TransactionDetailDialog/TransactionDetailDialog";
import styles from "./ViewTreasury.scss";
import settings from "settings";




export type ViewTreasury_Props = {
  transactions: Array<any>;
  selectedTab: number;
  isDistributionVisible: boolean;
  filterStartDate: moment | null;
  filterEndDate: moment | null;
  totalBalanceList: Balance;
  totalTransactionsSum: Balance;
  clanId: number;
  members: Array<any>; // TODO add Member description
  distributionList: Array<number>;
  distributionSum: number;
  selectedDistributionCurrency: CurrencyType;
  isTotalTransactionsSumUpdating: boolean;
  isTransactionListUpdating: boolean;
  permissions: Array<string>;
  isDistributionResultDialogVisible: boolean;
  detailViewTransaction: Transaction | null;
  isAppending: boolean;
  id: number;
  distributionPlayerFilter: string;
  isDistributionFilterInputVisible: boolean;
  sortDirection: null | "ask" | "desk";
  sortField: string | null;
  languageCode: string;
  formats: IDateFormats;
  treasuryMinDistributionSumm: number;
  treasuryMinDaysInClan: number;

  selectDistributionCurrency: (type: CurrencyType) => void;
  setSelectedTab: (index: string | number) => void;
  showDistributionDialog: () => void;
  hideDistributionDialog: () => void;
  setFilterDates: (start: moment, end: moment) => void;
  fetchMembers: (clanId: number) => void;
  toggleDistributionMembers: (members: Array<any>, toggleAll: boolean) => void;
  setDistributionSum: (sum: number) => void;
  distributeResources: () => void;
  hideDistributionResultDialog: () => void;
  showDistributionResultDialog: (transaction: Transaction) => void;
  appendTransactions: () => void;
  repeatFailedDistribution: () => void;
  setDistributionFilter: (value: string) => void;
  toggleIsDistributionFilterVisible: () => void;
  setSortField: (field: string) => void;
  navigateToTreasuryBuilding: () => void,
};

class ViewTreasury extends PureComponent<ViewTreasury_Props, any> {

  componentDidMount() {
    dwhExport.send('treasury.open_page')
  }


  showDistributeTable = () => {
    this.props.setSelectedTab(2);
  };

  showRegularRewardsTab = () => {
    this.props.setSelectedTab(3)
  }

  getDistributionDialogContent = () => {
    return (
      <DistributionDialog
        distributionList={this.props.distributionList}
        distributionSum={this.props.distributionSum}
        members={this.props.members}
        hideDistributionDialog={this.props.hideDistributionDialog}
        setDistributionSum={this.props.setDistributionSum}
        totalBalanceList={this.props.totalBalanceList}
        selectedDistributionCurrency={this.props.selectedDistributionCurrency}
        selectDistributionCurrency={this.props.selectDistributionCurrency}
        distributeResources={this.props.distributeResources}
        treasuryMinDistributionSumm={this.props.treasuryMinDistributionSumm}
      />
    )
  }


  getDistributionResultDialogContent = () => {

    if (this.props.detailViewTransaction) {
      const offerId = get(this.props.detailViewTransaction, 'data.offer', undefined)
      const reward = offerId ? this.props.regularRewards.availableRewardOffers.filter(r => r.offer_id === offerId)[0] : undefined

      return (
        <TransactionDetailDialog
          repeatTreasuryBoxTransaction={this.props.repeatTreasuryBoxTransaction}
          hideDistributionResultDialog={this.props.hideDistributionResultDialog}
          detailViewTransaction={this.props.detailViewTransaction}
          repeatFailedDistribution={this.props.repeatFailedDistribution}
          members={this.props.members}
          reward={reward}
        />
      )
    } else {
      return null
    }
  }

  getTabContent = () => {
    const isSpends = this.props.selectedTab === 0
    const canDistribute = this.props.permissions.indexOf('divide_profits') !== -1


    switch (this.props.selectedTab) {
      case 3: {
        return (
          <RegularRewards
            navigateToTreasuryBuilding={this.props.navigateToTreasuryBuilding}
            canDistribute={canDistribute}
          />
        )
      }
      case 2: {
        return (
          <Distribution
            fetchMembers={this.props.fetchMembers}
            clanId={this.props.clanId}
            members={this.props.members}
            distributionList={this.props.distributionList}
            toggleDistributionMembers={this.props.toggleDistributionMembers}
            showDistributionDialog={this.props.showDistributionDialog}
            id={this.props.id}
            distributionPlayerFilter={this.props.distributionPlayerFilter}
            setDistributionFilter={this.props.setDistributionFilter}
            toggleIsDistributionFilterVisible={this.props.toggleIsDistributionFilterVisible}
            isDistributionFilterInputVisible={this.props.isDistributionFilterInputVisible}
            sortDirection={this.props.sortDirection}
            sortField={this.props.sortField}
            setSortField={this.props.setSortField}
            treasuryMinDaysInClan={this.props.treasuryMinDaysInClan}
          />
        )
      }
      default: {
        return (
          <History
            isSpend={isSpends}
            startDate={this.props.filterStartDate}
            endDate={this.props.filterEndDate}
            setFilterDates={this.props.setFilterDates}
            transactions={this.props.transactions}
            totalBalanceList={this.props.totalBalanceList}
            totalTransactionsSum={this.props.totalTransactionsSum}
            isTotalTransactionsSumUpdating={this.props.isTotalTransactionsSumUpdating}
            isTransactionListUpdating={this.props.isTransactionListUpdating}
            showDistributionResultDialog={this.props.showDistributionResultDialog}
            isAppending={this.props.isAppending}
            appendTransactions={this.props.appendTransactions}
            languageCode={this.props.languageCode}
            formats={this.props.formats}
            regularRewards={this.props.regularRewards}
          />
        )
      }
    }
  }

  render() {
    const canDistribute = this.props.permissions.indexOf('divide_profits') !== -1
    const bundlesEnabled = settings.treasury.bundlesEnabled
    const isDistributionTab = this.props.selectedTab === 2
    const isRegularRewardsTab = this.props.selectedTab === 3
    const isSpends = this.props.selectedTab === 0

    return (
      <div className={styles.wrapper}>
        <span className={styles.pageTitle}>{t('Ресурсы клана')}</span>
        <div className={styles.clanBalance}>
          <ClanBalance
            totalBalanceList={this.props.totalBalanceList}
          />
        </div>
        <div className={styles.actionsRow}>
          <Tabs
            isUppercase
            smallHeight
            tabSelected={this.props.selectedTab}
            tabs={[
              { value: 0, content: t('Расходы') },
              { value: 1, content: t('Доход') },
            ]}

            onToggleTab={this.props.setSelectedTab}
          />

          <div className={styles.separator} />

          {canDistribute ? (
            <div className={`${isDistributionTab ? styles.distributeActive : ''} ${styles.distribute}`}>
              <span onClick={this.showDistributeTable}>{t('Распределить ресурсы')}</span>
            </div>
          ) : null}

          {bundlesEnabled ? (<div
            className={`${isRegularRewardsTab ? styles.regularRewardsActive : ''} ${styles.regularRewards}`}
          >
            <span onClick={this.showRegularRewardsTab}>{t('Контейнеры для клана')}</span>
          </div>
          ) : null}

        </div>
        <Divider type="major" />
        <div className={styles.tabContent}>
          {this.getTabContent()}
        </div>
        <Dialog
          content={this.getDistributionDialogContent()}
          size={'small'}
          isOverlay={false}
          isVisible={this.props.isDistributionVisible}
          hideDialog={this.props.hideDistributionDialog}
          t={t}
        />
        <Dialog
          content={this.getDistributionResultDialogContent()}
          size={'small'}
          isOverlay={false}
          isVisible={this.props.isDistributionResultDialogVisible}
          hideDialog={this.props.hideDistributionResultDialog}
          t={t}
        />
      </div>
    )
  }
}

export default ViewTreasury;